import React, { FC, useContext, useMemo } from 'react';
import { Icon, Segment }                  from 'semantic-ui-react';

import { stringToColor }                        from '../../../../../util';
import { Align, CorvalUIColor, Position, Size } from '../../../../../types';
import { StyledContainer }                      from '../../../../containers';
import { HexagonShape }                         from '../../../../components/util/visual/HexagonShape';
import { DashboardProjectListItemContext }      from './ProjectListItem';
import { CorvalAssistantMagicContainer }        from "@src/views/components/product/CorvalAssistantMagicContainer";


interface Props {}

const defaultProps: Props = {}

const ProjectListItemContainer: FC<Props> = ( props ) => {

    let { project, projectStats } = useContext( DashboardProjectListItemContext );

    let projectColor = useMemo( () => stringToColor( project.id ), [ project ] );

    return (

        <Segment raised className={ 'container--rounded position--relative overflow--hidden outline--colored-teal outline-md outline--hover' }>


            <CorvalAssistantMagicContainer
                textColor={ CorvalUIColor.WHITE }
                textAlign={ Align.CENTER }
                padding={ Size.XS }
                mono={ true }
                dark={ true }
                style={ {
                    position:       'absolute',
                    top:            0,
                    left:           0,
                    right:          0,
                    height:         16,
                    display:        'flex',
                    justifyContent: 'flex-start',
                    alignItems:     'center',
                } }>

                <Icon name={ 'compass' } fitted size={ 'small' }/>

            </CorvalAssistantMagicContainer>

            { !projectStats.isDiscoveryComplete ? (

                <StyledContainer zIndex={ 100 } position={ Position.ABSOLUTE } top={ -300 } right={ -50 } className={ 'opacity--100' }>
                    <StyledContainer className={ 'opacity--5' }>
                        <HexagonShape customColor={ projectColor as any } size={ 800 } rotation={ 70 }/>
                    </StyledContainer>
                </StyledContainer>

            ) : (

                  <StyledContainer zIndex={ 100 } position={ Position.ABSOLUTE } top={ -240 } left={ -285 } className={ 'opacity--75' }>
                      <StyledContainer className={ 'opacity--5' }>
                          <HexagonShape customColor={ projectColor as any } size={ 800 } rotation={ 70 }/>
                      </StyledContainer>
                  </StyledContainer>

              ) }

            <StyledContainer position={ Position.RELATIVE } padding={ Size.MD } zIndex={ 200 }>

                { props.children }

            </StyledContainer>
        </Segment>
    );
};

ProjectListItemContainer.defaultProps = defaultProps;

export { ProjectListItemContainer }
